import CONSTANTS from "core/constants";
import { format, isToday } from "date-fns";
import {
  DayWrapper,
  Title,
  DayContent,
  Box,
} from "components/dashboard/styled";

enum BookingStatus {
  OPEN = "OPEN",
  BOOKED = "BOOKED",
  UNAVAILABLE = "UNAVAILABLE",
  CANCELED = "CANCELED",
  LATE_CANCELED = "LATE_CANCELED",
  NO_SHOW = "NO_SHOW",
  ORGANIZER_NO_SHOW = "ORGANIZER_NO_SHOW",
  NO_SHOW_ALL = "NO_SHOW_ALL",
  TOTAL = "TOTAL",
}

export type DayType = Record<
  BookingStatus,
  { count: number; percentage: number }
> & {
  date: number;
};

type Props = {
  day: DayType;
};

export const Day = (props: Props) => {
  const selectedDate = new Date(props.day.date * 1000);
  const isDateToday = isToday(selectedDate);

  const renderLinks = () => {
    const statuses = Object.keys(CONSTANTS.STATS_STATUS);
    return statuses.map((status) => {
      // 2021-04-26: Booking statuses and stats statuses deviate, dayDetails will not be
      // displayed for non booking statuses
      type Status = keyof typeof CONSTANTS.STATS_STATUS;
      if (status in CONSTANTS.BOOKING_STATUS) {
        return (
          <Box key={status} status={status} data-testid="daily-stat-cards">
            {props.day[status as Status]
              ? props.day[status as Status].count
              : 0}
          </Box>
        );
      }

      return (
        <span key={status}>
          <Box status={status}>
            {props.day[status as Status]
              ? props.day[status as Status].count
              : 0}
          </Box>
        </span>
      );
    });
  };

  return (
    <DayWrapper isToday={isDateToday}>
      <Title isToday={isDateToday}>{format(selectedDate, "dd")}</Title>
      <DayContent>{renderLinks()}</DayContent>
    </DayWrapper>
  );
};
